import _implicitStylesheets from "./carousel.css";
import _implicitScopedStylesheets from "./carousel.scoped.css?scoped=true";
import _aceLightbox from "ace/lightbox";
import _listingVideoPreview from "listing/videoPreview";
import _adsImage from "ads/image";
import _wdsAnalyticsInstrument from "wds/analyticsInstrument";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<div class="footer${0}"${2}><span type-style="body-2"${3}><p${3}>${"t3"}</p></span></div>`;
const stc0 = {
  classMap: {
    "carousel": true
  },
  key: 1
};
const stc1 = {
  "card": true
};
const stc2 = {
  classMap: {
    "content-image": true
  },
  key: 5
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {b: api_bind, c: api_custom_element, k: api_key, ti: api_tab_index, h: api_element, d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, i: api_iterator} = $api;
  const {_m0, _m1, _m2} = $ctx;
  return [$cmp.showLightbox ? api_custom_element("ace-lightbox", _aceLightbox, {
    props: {
      "items": $cmp.lightboxItems,
      "initialItemPosition": $cmp.initialLightboxItemPosition,
      "isMobile": $cmp.isMobile,
      "ga4EventType": "carousel"
    },
    key: 0,
    on: {
      "close": _m0 || ($ctx._m0 = api_bind($cmp.toggleLightbox))
    }
  }) : null, $cmp.mediaItems ? api_element("ul", stc0, api_iterator($cmp.processedMediaItems, function (item) {
    return api_element("li", {
      key: api_key(2, item.key)
    }, [api_element("button", {
      classMap: stc1,
      attrs: {
        "data-position": item.key,
        "tabindex": api_tab_index(item.cardTabIndex)
      },
      key: 3,
      on: {
        "click": _m1 || ($ctx._m1 = api_bind($cmp.handleClick))
      }
    }, [item.isInteractive ? api_custom_element("listing-video-preview", _listingVideoPreview, {
      props: {
        "positionIndex": item.key,
        "providerLogo": $cmp.providerLogo,
        "variant": item.type,
        "altText": item.altText
      },
      key: 4
    }) : null, !item.isInteractive ? api_element("div", stc2, [api_custom_element("wds-analytics-instrument", _wdsAnalyticsInstrument, {
      props: {
        "type": "image",
        "positionIndex": item.key
      },
      key: 6,
      on: {
        "analytics": _m2 || ($ctx._m2 = api_bind($cmp.handleImageShown))
      }
    }, [api_custom_element("ads-image", _adsImage, {
      props: {
        "src": item.src,
        "width": "100%",
        "height": "333px",
        "variant": "carousel",
        "alt": item.altText,
        "isLoading": item.showLoadingImage
      },
      key: 7
    })])]) : null, item.hasFooter ? api_static_fragment($fragment1, 9, [api_static_part(3, null, api_dynamic_text(item.caption))]) : null])]);
  })) : null];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-3e5jt2sn9of";
tmpl.legacyStylesheetToken = "undefined-_carousel";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
